import { render, staticRenderFns } from "./DocUpload.vue?vue&type=template&id=746a464d&scoped=true&"
import script from "./DocUpload.vue?vue&type=script&lang=js&"
export * from "./DocUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocUpload.vue?vue&type=style&index=0&id=746a464d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a464d",
  null
  
)

export default component.exports